import imagelogo from '../../../../../Assests/ReportImages/certin.jpg'
import logo from '../../../../../Assests/ReportImages/isecurion1.png';
import { AlignmentType, FrameAnchorType, HorizontalPositionAlign, HorizontalPositionRelativeFrom, ImageRun, Paragraph, TextRun, VerticalPositionAlign, VerticalPositionRelativeFrom, WidthType } from 'docx'

const imageData = await fetch(imagelogo).then(response => response.blob());
const isecurionLogoo = await fetch(logo).then(response => response.blob());

const image = new ImageRun({
  data: await imageData.arrayBuffer(),
  transformation: { width: 816, height: 1056 },
  floating: {
    zIndex: 5,
    horizontalPosition: {
      relative: HorizontalPositionRelativeFrom.PAGE,
      align: HorizontalPositionAlign.CENTER,
    },
    verticalPosition: {
      relative: VerticalPositionRelativeFrom.PAGE,
      align: VerticalPositionAlign.TOP,
    },
  }
});

const image2 = new ImageRun({
  type: 'png',
  data: await isecurionLogoo.arrayBuffer(),
  transformation: { width: 310, height: 82 },
  floating: {
    zIndex: 10,
    horizontalPosition: { offset: 300000 },
    verticalPosition: { offset: 400000 },
  }
});

export const certinNetworkDesign = new Paragraph({
  children: [image]
})

export const fontPageNetworkBlueImage = new Paragraph({
  children: [image2]
})


export function reportNetworkName(certInNetworkCustomerName) {
  return new Paragraph({
    width: { size: 50, type: WidthType.PERCENTAGE },
    alignment: AlignmentType.CENTER,
    spacing: { line: 276, before: 100, after: 100 },
    frame: {
      type: "absolute",
      position: {
        x: 700,
        y: 6000,
      },
      width: 9000,
      height: 1000,
      anchor: {
        horizontal: FrameAnchorType.MARGIN,
        vertical: FrameAnchorType.MARGIN,
      },
      alignment: {
        x: HorizontalPositionAlign.CENTER,
        y: VerticalPositionAlign.CENTER,
      },
      zIndex: 90,
    },

    children: [
      new TextRun({
        text: `Security Audit Phase - 1 Internal Network Vulnerability Assessment and Penetration Testing Report of ${certInNetworkCustomerName}`,
        font: "Calibri",
        size: 56,
        color: '0070C0',
        allCaps: false,
        italics: false
      }),
    ],
  });
}


export function reportNetworkDate(dateString) {
  const date = new Date(dateString);

  function getOrdinalSuffix(day) {
    if (day > 3 && day < 21) return 'th';
    else {
      switch (day % 10) {
        case 1: return 'st';
        case 2: return 'nd';
        case 3: return 'rd';
        default: return 'th';
      }
    }
  }

  const formattedDate = `${date.getDate()}`;
  const ordinalSuffix = getOrdinalSuffix(date.getDate());
  const formatMonth = (date.getMonth() + 1).toString();
  const formatYear = date.getFullYear();

  return new Paragraph({
    width: { size: 70, type: WidthType.PERCENTAGE },
    alignment: AlignmentType.CENTER,
    spacing: { line: 276, before: 100, after: 100 },
    frame: {
      type: "absolute",
      position: {
        x: 700,
        y: 9500,
      },
      width: 9000,
      height: 1000,
      anchor: {
        horizontal: FrameAnchorType.MARGIN,
        vertical: FrameAnchorType.MARGIN,
      },
      alignment: {
        x: HorizontalPositionAlign.CENTER,
        y: VerticalPositionAlign.CENTER,
      },
      zIndex: 90,
    },

    children: [
      new TextRun({
        text: "Report Submission Date: ",
        font: "Calibri",
        size: 56,
        color: '0070C0',
        allCaps: false,
        italics: false
      }),
      new TextRun({
        text: formattedDate,
        font: "Calibri",
        size: 56,
        color: '0070C0',
        italics: false
      }),
      new TextRun({
        text: '-' + formatMonth + '-' + formatYear,  // Format month as a number
        font: "Calibri",
        size: 56,
        color: '0070C0',
        italics: false
      })
    ],
  });
}

